import React from 'react'
import style from './index.module.less'
import { Carousel } from "@/new_components/CustomCarousel"
import { LearnBuyBtn } from "@/new_components"
import { useIntl } from "react-intl"
import useBigScreen from "@/hooks/bigScreen"
import getCountry from '@/utils/getCountry.js'
import { buy_link } from '@/scripts/constant.js'
import { 
  Neo_Desktop,
  Neo_Mobile,
  home_Eye_Desktop,
  home_Eye_Mobile, 
  home_OnePro_Desktop, 
  home_OnePro_Mobile,
  home_Aura_Desktop,
  home_Aura_Mobile,
  home_herosection_BP_Desktop,
  home_herosection_BP_Mobile,
  tradein_Desktop,
  tradein_Mobile
} from "@/images/home/index"

const Hero = (props) => {
  const intl = useIntl()
  const { carItem, index } = props

  const handleImgLink = (sensorsData) => {
    typeof (sensors) !== "undefined" && sensors.track('PageClick', {
      custom: {
        module_id: sensorsData?.module_id,
        module_name: sensorsData?.module_name
      }
    });
  }

  return ( 
    <div className={style.carouselSlide}
      key={index}
      style={{backgroundImage: `url(${carItem.img})`, alignItems: carItem.alignItems || 'flex-end'}}
    >
      {!!carItem.imgLink && <a className={style.imgLink} href={carItem.imgLink} onClick={()=>handleImgLink(carItem.sensorsData)} target="_blank" aria-label="trade in">&nbsp;</a>}
      <div className={style.slidesContent}>
        <div className={style.text}>
          {!!carItem.tip1 && <span className={style.tip1}>{intl.formatMessage({ id: carItem.tip1 })}</span>}
          {!!carItem.title && <span className={style.title}>{carItem.title }</span>}
          {!!carItem.tip2 && <span className={style.tip2}>{intl.formatMessage({ id: carItem.tip2 })}</span>}
        </div>

        {carItem?.btnList?.length > 0 && <div className={style.btnbox}>
          {carItem.btnList.map((btnItem, btnIndex) => 
            <LearnBuyBtn key={`home-${index}-${btnItem.btnType}-${btnIndex}`} link_out={btnItem.btnOut} link={btnItem.btnLink} btnText={btnItem.btnText} btnType={btnItem.btnType} />
          )}
        </div>}
      </div>
    </div>
  )
}
const HeroSection = () => {
  const region = getCountry()
  const ifPc = useBigScreen(1000)
  const intl = useIntl()
  const moreLang = intl.formatMessage({ id: "learn_more" })
  const buyLang = intl.formatMessage({ id: "buy_now" })
  const OPTIONS = { loop: true }
  const SLIDES = [
    {
      img: ifPc ? home_OnePro_Desktop : home_OnePro_Mobile,
      tip1: "homenew_one_pro_tip1",
      title: "XREAL One Pro",
      tip2: "homenew_one_pro_tip2",
      btnList: [
        {
          btnLink: "/one-pro",
          btnOut: false,
          btnType: "learn",
          btnText: moreLang
        },
        {
          btnLink: buy_link[region].onepro.shop,
          btnOut: true,
          btnType: "buy",
          btnText: buyLang
        }
      ]
    },
    {
      img: ifPc ? home_Aura_Desktop : home_Aura_Mobile,
      tip1: "homenew_aura_tip1",
      title: "Project Aura",
      tip2: "aura_slogan",
      btnList: [
        {
          btnLink: "/aura",
          btnOut: false,
          btnType: "learn",
          btnText: moreLang
        }
      ]
    },
    {
      img: ifPc ? Neo_Desktop : Neo_Mobile,
      tip1: "homenew_neo_tip1",
      title: "XREAL Neo",
      tip2: "homenew_neo_tip2",
      btnList: [
        {
          btnLink: "/neo",
          btnOut: false,
          btnType: "learn",
          btnText: moreLang
        }
      ]
    }
  ]

  const SLIDES_jp = [
    {
      img: ifPc ? home_OnePro_Desktop : home_OnePro_Mobile,
      tip1: "homenew_one_pro_tip1",
      title: "XREAL One Pro",
      tip2: "homenew_one_pro_tip2",
      btnList: [
        {
          btnLink: "/one-pro",
          btnOut: false,
          btnType: "learn",
          btnText: moreLang
        },
        {
          btnLink: buy_link[region].onepro.shop,
          btnOut: true,
          btnType: "buy",
          btnText: buyLang
        }
      ]
    },
    {
      img: ifPc ? home_Aura_Desktop : home_Aura_Mobile,
      tip1: "homenew_aura_tip1",
      title: "Project Aura",
      tip2: "aura_slogan",
      btnList: [
        {
          btnLink: "/aura",
          btnOut: false,
          btnType: "learn",
          btnText: moreLang
        }
      ],
    },
    {
      img: ifPc ? home_Eye_Desktop : home_Eye_Mobile,
      tip1: "homenew_eye_tip1",
      title: "XREAL Eye",
      tip2: "homenew_eye_tip2",
      btnList: [
        {
          btnLink: "/eye/",
          btnOut: false,
          btnType: "learn",
          btnText: moreLang
        },
        {
          btnLink: buy_link[region].xrealeye, 
          btnOut: true,
          btnType: "buy",
          btnText: buyLang
        }
      ]
    },
    {
      img: ifPc ? home_herosection_BP_Desktop: home_herosection_BP_Mobile,
      tip1: "homenew_beam_pro_tip1",
      title: "XREAL Beam Pro",
      tip2: "homenew_beam_pro_tip2",
      btnList: [
        {
          btnLink: "/beampro",
          btnOut: false,
          btnType: "learn",
          btnText: moreLang
        },
        {
          btnLink: buy_link[region]["beampro"].shop,
          btnOut: true,
          btnType: "buy",
          btnText: buyLang
        }
      ]
    },
  ]

  const SLIDES_TRADEIN = [
    {
      img: ifPc ? tradein_Desktop : tradein_Mobile,
      imgLink: "https://us.shop.xreal.com/collections/trade-in-program",
      sensorsData: {
        module_id: "10020",
        module_name: "home_trade_in_image"
      }
      
    },
    {
      img: ifPc ? home_OnePro_Desktop : home_OnePro_Mobile,
      tip1: "homenew_one_pro_tip1",
      title: "XREAL One Pro",
      tip2: "homenew_one_pro_tip2",
      btnList: [
        {
          btnLink: "/one-pro",
          btnOut: false,
          btnType: "learn",
          btnText: moreLang
        },
        {
          btnLink: buy_link[region].onepro.shop,
          btnOut: true,
          btnType: "buy",
          btnText: buyLang
        }
      ]
    },
    {
      img: ifPc ? home_Aura_Desktop : home_Aura_Mobile,
      tip1: "homenew_aura_tip1",
      title: "Project Aura",
      tip2: "aura_slogan",
      btnList: [
        {
          btnLink: "/aura",
          btnOut: false,
          btnType: "learn",
          btnText: moreLang
        }
      ]
    }
  ]

  const showTradeIn = region === "us" || region === "base";
  let SLIDES_DIFF_REGION
  if (region === 'jp') {
    SLIDES_DIFF_REGION = SLIDES_jp
  } else if (showTradeIn) {
    SLIDES_DIFF_REGION = SLIDES_TRADEIN
  } else {
    SLIDES_DIFF_REGION = SLIDES
  }

  return (
    <div className={style.heroSection}>
      <Carousel 
        slides={SLIDES_DIFF_REGION} 
        options={OPTIONS}
        CustomContentComponent={Hero} 
        customControlsSty={style.carouselControls} 
        customDotsColorSty={style.carouselDotsColor}
        customDotSelectedSty={style.carouselDotSelected}
        showArrowsBtn={ifPc}
      />
    </div>
  )
}

export default HeroSection